module.exports = __webpack_public_path__ + "img/BlendBuff-Bearish.07e20699.png";